/** Backend code when a membership discount and a promo are both on the sale. */
export const MEMBERSHIP_PROMO_CONFLICT_CODE =
  'MembershipDiscountPromoCompoundingNotAllowed';
